import { assertNever } from "@suse-o11y/assert-never";
import {
	millisecondsToMinutes,
	millisecondsToSeconds,
	minutesToMilliseconds,
	secondsToMilliseconds,
} from "@suse-o11y/date-time";
import { msPerFrame } from "@suse-o11y/ms-per-frame";
import type { Record } from "@suse-o11y/record";

export type UseNowFloor = "milliseconds" | "seconds" | "minutes";

export const MINIMAL_FLOOR_INTERVAL = {
	milliseconds: msPerFrame(60),
	seconds: msPerFrame(10),
	minutes: msPerFrame(1),
} satisfies Record<UseNowFloor>;

export function floorMilliseconds(ms: number, floor: UseNowFloor): number {
	switch (floor) {
		case "milliseconds": {
			return ms;
		}

		case "seconds": {
			return secondsToMilliseconds(millisecondsToSeconds(ms));
		}

		case "minutes": {
			return minutesToMilliseconds(millisecondsToMinutes(ms));
		}

		default: {
			return assertNever(floor);
		}
	}
}
